import React, { Component } from 'react';
import MUIDataTable from 'mui-datatables';
import { Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import { Link } from 'react-router-dom';
import { MODALACTION, RESPONSE } from '../../config/constants';
import ReactNotification, {store} from 'react-notifications-component';
import Services from '../../services/service';
import DatePicker from 'react-datepicker';
import moment from 'moment';
import { MuiThemeProvider } from '@material-ui/core/styles';
import {getMuiTheme, tableOptions} from '../../util/MuiTableTheme';
import {BASE_URL} from '../../config/constants';

const { VIEW } = MODALACTION;
const { FAILED } = RESPONSE;
const tableOptionsDetail = {
  filterType: 'dropdown',
  selectableRows: 'none',
  search: false,
  filter: false,
  download: false,
  print: false,
  viewColumns: false,
  pagination: false,
  setTableProps: () => {
    return {
      size: "small"
    };
  }
};

class VehicleList extends Component {

  constructor(props){
    super(props);
    this.state = {
      modalAdd: false,
      detailNotes: '',
      actionModal: '',
      selectedItem: {},
      dataLogList: [],
      vehicleLogDetail: [],
      showTable: true,
      date: moment().format('DD-MM-YYYY'),
    };
    this.initialState = this.state;
  }

  componentDidMount(){
    this.getDataLogList();
  }

  addNotification = (notificationType, notificationTitle, notificationMessage, notificationPosition) => {
    store.addNotification({
      title: notificationTitle,
      message: notificationMessage,
      type: notificationType,
      insert: "top",
      container: notificationPosition,
      animationIn: ["animated", "fadeIn"],
      animationOut: ["animated", "fadeOut"],
      dismiss: { duration: 2000 },
      dismissable: { click: true }
    });
  };

  toggleNotification = action => {
    if (action === FAILED) {
      this.addNotification('danger', 'Danger', 'Oops something went wrong !', 'top-right');
    }
  };

  _renderDatePicker = () => (
    <DatePicker
      value={this.state.date}
      placeholderText="Click to select a date"
      onChange={this._handleDateChange}
      onCalendarClose={this._handleCalendarClose}
      onCalendarOpen={this._handleCalendarOpen}
    />
  );

  _handleDateChange = value => {
    this.setState({
      detailDate: moment(value).locale('id').format('DD MMMM YYYY'),
      date: moment(value).format('DD-MM-YYYY')
    });
  };

  _handleCalendarOpen = () => {
    this.setState({showTable: false})
  };

  _handleCalendarClose = () => {
    this.setState({showTable: true});
  };

  getDataLogList = () => {
    Services.getLogList({date: this.state.date})
      .then(res => {
        this.setState({ dataLogList: res });
      })
      .catch(err => console.log(err))
  };

  renderBreadcrumb = () => (
    <div style={{marginBottom: 10}}>
      <ol className="breadcrumb float-xl-right">
        <li className="breadcrumb-item"><Link to="/">Home</Link></li>
        <li className="breadcrumb-item active">Parkir Kendaraan</li>
      </ol>
      <h1 className="page-header"> Laporan Parkir Kendaraan </h1>
      {/*{this._renderDatePicker()}*/}
    </div>
  );

  renderTableVehicleList = () => {
    const { dataLogList } = this.state;
    const columns = [
      {
        name: "no",
        label: "No",
        options: {
          filter: true,
          sort: true,
          customBodyRender: (value, tableMeta) => tableMeta.rowIndex + 1
        }
      },
      {
        name: "timeIn",
        label: "Masuk",
        options: {
          filter: true,
          sort: true
        }
      },
      {
        name: "timeOut",
        label: "Keluar",
        options: {
          filter: true,
          sort: true
        }
      },
      {
        name: "cardNumber",
        label: "No Kartu",
        options: {
          filter: true,
          sort: true
        }
      },
      {
        name: "vehicleNumber",
        label: "Nomor Polisi",
        options: {
          filter: true,
          sort: true
        }
      },
      {
        name: "vehicleType",
        label: "Tipe Kendaraan",
        options: {
          filter: true,
          sort: true,
        }
      },
      {
        name: "color",
        label: "Warna",
        options: {
          filter: true,
          sort: true,
        }
      },
      {
        name: "countHours",
        label: "Durasi",
        options: {
          filter: true,
          sort: true,
        }
      },
      {
        name: "status",
        label: "Status",
        options: {
          filter: true,
          sort: true,
        }
      },
      {
        name: "_id",
        label: "Aksi",
        options: {
          filter: false,
          sort: false,
          setCellProps: () => ({ style: { minWidth: "200px" }}),
          customBodyRender: (value, tableMeta) => {
            return (
              <div className="with-btn text-nowrap">
                <button
                  className="btn btn-sm btn-primary width-60 m-r-2"
                  onClick={() => this.onCLickVehicleDetail(VIEW, dataLogList.find(item => item._id === value))}
                >{VIEW}</button>
              </div>
            );
          }
        }
      }
    ];

    return (
      <MuiThemeProvider theme={getMuiTheme()}>
        <MUIDataTable
          title={"List Parkir Kendaraan"}
          data={dataLogList}
          columns={columns}
          options={tableOptions}
        />
      </MuiThemeProvider>
    )
  };

  onCLickVehicleDetail = (method, data) => {
    this.toggleAddModal(method, data);
    const param = data._id;
    Services.getVehicleLogDetail(param)
      .then(res => {
        this.setState({
          vehicleLogDetail: res,
          detailNotes: res.detail.notes,
          startTimeImage: res.detail.imageIn,
          endTimeImage: res.detail.imageOut,
          duration: res.detail.duration
        });
      })
      .catch(err => {
        console.log(err);
        this.toggleNotification(FAILED);
      });
  };

  renderDetailNotes = () => (
    <>
      <div className="row m-t-15">
        <label className='col-md-1 text-right'><h5><b>Notes :</b></h5></label>
        <label className='col-md-auto'><h5>{this.state.detailNotes}</h5></label>
        {/* <div className='col-md-11'>
          <input
            type="text" className="form-control" disabled
            defaultValue={this.state.detailNotes}
          />
        </div> */}
      </div>
      <div className="row">
        <label className='col-md-1 text-right'><h5><b>Durasi :</b></h5></label>
        <label className='col-md-auto'><h5 className='text-danger'>{this.state.duration}</h5></label>
      </div>
    </>
  );

  renderVehicleDetail = () => {
    const { vehicleLogDetail } = this.state;
    let detailVehicle = [];
    detailVehicle.push(vehicleLogDetail.detail);
    const columns = [
      {
        name: "vehicleNumber",
        label: "No Polisi",
        options: {
          filter: true,
          sort: true,
        }
      },
      {
        name: "vehicleCategory",
        label: "Kategori Kendaraan",
        options: {
          filter: true,
          sort: true,
        }
      },
      {
        name: "vehicleType",
        label: "Tipe Kendaraan",
        options: {
          filter: true,
          sort: true,
        }
      },
      {
        name: "color",
        label: "Warna",
        options: {
          filter: true,
          sort: true,
        }
      },
      {
        name: "cardNumber",
        label: "No Kartu",
        options: {
          filter: true,
          sort: true,
        }
      }
    ];

    return (
      <MuiThemeProvider theme={getMuiTheme()}>
        <MUIDataTable
          data={detailVehicle}
          columns={columns}
          options={tableOptionsDetail}
        />
      </MuiThemeProvider>
    )
  };

  renderImageIn = () => {
    return(
      <div className='text-center m-t-5'>
        <img
          src={`${BASE_URL}/vehicle-log-file/${this.state.startTimeImage}`} 
          alt="park_in"
          height="400px"
          style={{maxWidth: "100%"}}
        />
      </div>
    )
  };

  renderImageOut = () => {
    return(
      <div className='text-center m-t-5'>
        <img 
          src={`${BASE_URL}/vehicle-log-file/${this.state.endTimeImage}`} 
          alt="park_out"
          height="400px"
          style={{maxWidth: "100%"}}
        />
      </div>
    )
  };

  renderTableMasuk = () => (
    <div>
      {this.renderImageIn()}
      {this.renderDataMasuk()}
    </div>
  );

  renderTableKeluar = () => (
    <div>
      {this.renderImageOut()}
      {this.renderDataKeluar()}
    </div>
  );

  renderDataMasuk = () => {
    const { vehicleLogDetail } = this.state;
    let detailVehicle = [];
    detailVehicle.push(vehicleLogDetail.detail);
    const columns = [
      {
        name: "timeIn",
        label: "Jam",
        options: {
          filter: true,
          sort: true,
        }
      },
      {
        name: "createBy",
        label: "Security",
        options: {
          filter: true,
          sort: true,
        }
      }
    ];

    return (
      <div className='m-t-5'>
        <MuiThemeProvider theme={getMuiTheme()}>
          <MUIDataTable
            data={detailVehicle}
            columns={columns}
            options={tableOptionsDetail}
          />
        </MuiThemeProvider>
      </div>
    )
  };

  renderDataKeluar = () => {
    const { vehicleLogDetail } = this.state;
    let detailVehicle = [];
    detailVehicle.push(vehicleLogDetail.detail);
    const columns = [
      {
        name: "timeOut",
        label: "Jam",
        options: {
          filter: true,
          sort: true,
        }
      },
      {
        name: "createBy",
        label: "Security",
        options: {
          filter: true,
          sort: true,
        }
      }
    ];

    return (
      <div className='m-t-5'>
        <MuiThemeProvider theme={getMuiTheme()}>
          <MUIDataTable
            data={detailVehicle}
            columns={columns}
            options={tableOptionsDetail}
          />
        </MuiThemeProvider>
      </div>
    )
  };

  renderChecklist = () => {
    const { vehicleLogDetail } = this.state;
    let detailVehicle = vehicleLogDetail.history;
    const columns = [
      {
        name: "image",
        label: "Foto",
        options: {
          filter: true,
          sort: true,
          customBodyRender: (image) => {
            return (    
              <img 
                src={`${BASE_URL}/vehicle-log-file/${image}`} 
                alt={"vehicle_checklist"}
                height="150px"
                style={{maxWidth: "100%"}}
              />
            )
          }
        }
      },
      {
        name: "createDate",
        label: "Dicek jam",
        options: {
          filter: true,
          sort: true,
          customBodyRender: value => moment(value).format('DD-MM-YYYY hh:mm')
        }
      },
      {
        name: "createBy",
        label: "Petugas",
        options: {
          filter: true,
          sort: true,
        }
      },
      {
        name: "notes",
        label: "Catatan",
        options: {
          filter: true,
          sort: true,
        }
      }
    ];

    return (
      <div style={{flex: 1}}>
        <MuiThemeProvider theme={getMuiTheme()}>
          <MUIDataTable
            data={detailVehicle}
            columns={columns}
            options={tableOptionsDetail}
          />
        </MuiThemeProvider>
      </div>
    )
  };

  //Start Modal Method

  toggleAddModal = (action = '', item = {}) => {
    this.setState({
      modalAdd: !this.state.modalAdd,
      actionModal: action,
      selectedItem: item
    });
  };

  renderDetailVehicleModal = () => (
    <Modal size="xl" style={{ width: '100%'}} isOpen={this.state.modalAdd} toggle={() => this.toggleAddModal()}>
      <ModalHeader toggle={() => this.toggleAddModal()}>Vehicle Log Detail</ModalHeader>
      <ModalBody>
        <ModalHeader>Detail Kendaraan</ModalHeader>
        {this.renderVehicleDetail()}
        {this.renderDetailNotes()}
        <div className='row'>
          <div className='col-xl-6'>
            <ModalHeader>Masuk</ModalHeader>
            {this.renderTableMasuk()}
          </div>
          <div className='col-xl-6'>
            <ModalHeader>Keluar</ModalHeader>
            {this.renderTableKeluar()}
          </div>
        </div>
        <ModalHeader>Checklist Kendaraan</ModalHeader>
        {this.renderChecklist()}
      </ModalBody>
      <ModalFooter>
        <button className="btn btn-white" onClick={() => this.toggleAddModal()}>Back</button>
      </ModalFooter>
    </Modal>
  );

  //End Modal Method

  render() {
    return (
      <div>
        <ReactNotification/>
        {this.renderBreadcrumb()}
        <div>
          {this.state.showTable && this.renderTableVehicleList()}
        </div>
        {this.renderDetailVehicleModal()}
      </div>
    )
  }
}

export default VehicleList;
